<template>
  <div v-if="isMobileAppEnabled" class="profile--settings--row text-black-900 dark:text-slate-300 row">
    <div class="w-[25%] py-4 pr-6 ml-0">
      <h4 class="block-title text-black-900 dark:text-slate-200">
        {{ $t('PROFILE_SETTINGS.FORM.MOBILE_SECTION.TITLE') }}
      </h4>
      <p>{{ $t('PROFILE_SETTINGS.FORM.MOBILE_SECTION.NOTE') }}</p>
    </div>
    <div class="p-4 w-[45%] flex flex-row">
      <qr-code-generator />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NotificationTableWrap from './NotificationTable.vue';
import hookMixin from "../integrationapps/hookMixin";
import QrCodeGenerator from "../integrations/OnlineCubedView/MobileApp/QrCodeGenerator.vue";

export default {
  components: {QrCodeGenerator, NotificationTableWrap },
  mixins: [hookMixin],
  computed: {
    integration() {
      return this.$store.getters['integrations/getIntegration']('mobile_app');
    },
    isMobileAppEnabled() {
      return !!this.integration?.id && this.hasConnectedHooks;
    }
  },
  mounted() {
    this.$store.dispatch('integrations/get');
  },
};
</script>

<style lang="scss" scoped>

</style>
